module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_02.0c293202.jpg";